export default "__VITE_ASSET__BUbMgGd$__"